module.exports = __webpack_public_path__ + "img/namu_bg.f1c6a50d.png";